'use strict';

const Decimal = require('decimal.js');

const mathUtil = module.exports = {
  /**
   * Sum of array with decimaljs.
   * @param {*} data 
   * @param {*} key 
   * @returns 
   */
  sum: (data) => data.reduce((rSum, a) => Decimal(rSum).plus(a).toNumber(), 0),
  /**
   * sum of object array by key with decimaljs.
   * @param {*} data 
   * @param {*} key 
   * @returns 
   */
  sumBy: (data, key) => data.reduce((rSum, a) => Decimal(rSum).plus(a[key]||0).toNumber(), 0),
};